export default "__VITE_ASSET__DN5pV6tq__"